import { PAYEX_URL } from 'constants/config';
import { schemas } from 'constants/schemas';
import type { Field } from 'models/field';
import type { Section } from 'models/section';
import { fetchJson } from 'utils/fetchJson/fetchJson';
import { normalizeResponse } from 'utils/normalize/normalize';
import type { I18n } from 'utils/translations/translations';
import { translateRelationshipField } from './translator';

export type FetchSendersParams = {
  country: string;
  locale?: string;
  paymentMethod?: string;
  paymentMethodType?: string;
  paymentOption?: string;
  priceAmount?: number;
  priceCurrency?: string;
  purchaseCurrency?: string;
  type?: string;
  recipientCode?: string;
  i18n?: I18n;
};

const normalizeSenderFields = (
  fields: Field[] = [],
): {
  entities?: {
    fields: Record<string, Field>;
    sections: Record<string, Section>;
  };
  result?: string[];
} => {
  return fields.length
    ? normalizeResponse<{
        fields: Record<string, Field>;
        sections: Record<string, Section>;
      }>(fields, schemas.arrayOfFields)
    : {};
};

export const senders = {
  fetch: async ({
    country,
    locale = 'EN',
    paymentMethod,
    paymentMethodType,
    paymentOption,
    priceAmount,
    priceCurrency,
    purchaseCurrency,
    type,
    recipientCode,
    i18n,
  }: FetchSendersParams) => {
    const searchParams = new URLSearchParams({
      locale,
      country,
    });

    if (paymentMethod) {
      searchParams.append('payment_method', paymentMethod);
    }
    if (paymentMethodType) {
      searchParams.append('payment_method_type', paymentMethodType);
    }
    if (paymentOption) {
      searchParams.append('payment_option', paymentOption);
    }
    if (priceAmount !== undefined) {
      searchParams.append('price_amount', String(priceAmount));
    }
    if (priceCurrency) {
      searchParams.append('price_currency', priceCurrency);
    }
    if (purchaseCurrency) {
      searchParams.append('purchase_currency', purchaseCurrency);
    }
    if (type) {
      searchParams.append('type', type);
    }
    if (recipientCode) {
      searchParams.append('recipient_code', recipientCode);
    }

    const path = `${PAYEX_URL}/senders?${searchParams.toString()}`;
    const response = await fetchJson<{ fields?: Field[] }>(path);
    const fields = i18n
      ? translateRelationshipField(response.fields ?? [], i18n)
      : response.fields;
    return normalizeSenderFields(fields);
  },
};
